import clsx from 'clsx';
import { isArray, isDate, isObject, map } from 'lodash-es';

import { Json, JsonPrimitive } from 'types';

import { jsonViewerClasses } from './JsonViewer.styles';

type JsonItemProps<Primitives extends unknown = JsonPrimitive> = {
  className?: string;
  json: Json<Primitives>;
  prefix?: string;
};

const JsonItem = <Primitives extends unknown = JsonPrimitive>({
  className,
  json,
  prefix = '',
}: JsonItemProps<Primitives>) => {
  if (isArray(json)) {
    return (
      <ol className={clsx(jsonViewerClasses.array, className)}>
        {json.map((value, index) => {
          const key = `${prefix}-${index}`;
          return (
            <li key={key} className="JsonItem-item">
              <JsonItem json={value} prefix={key} className={jsonViewerClasses.arrayItem} />
            </li>
          );
        })}
      </ol>
    );
  }

  if (isObject(json) && !isDate(json)) {
    return (
      <ul className={clsx(jsonViewerClasses.object, className)}>
        {map(json, (value, name) => {
          const key = `${prefix}.${name}`;
          return (
            <li key={key} className="JsonItem-prop">
              <span className="JsonItem-key">{name}</span>: <JsonItem json={value} prefix={key} />
            </li>
          );
        })}
      </ul>
    );
  }

  const lines = isDate(json) ? [json.toUTCString()] : String(json).split('\n');
  if (lines.length > 1) {
    return (
      <pre className={clsx(jsonViewerClasses.value, className)}>
        {lines.map((line, index) => {
          const key = `${line}\0${index}`;
          return <div key={key}>{line}</div>;
        })}
      </pre>
    );
  }

  return <span className={clsx(jsonViewerClasses.value, className)}>{lines[0]}</span>;
};

export default JsonItem;
